import api from './api';

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  roleId: number;
  role?: {
    id: number;
    name: string;
    description?: string | null;
  };
  organizationName?: string | null;
  departmentName?: string | null;
  isActive: boolean;
  lastLogin?: string | null;
  timezone?: string | null;
  language?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface Role {
  id: number;
  name: string;
  description?: string | null;
}

export interface CreateUserData {
  username: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  roleId: number;
  organizationName?: string | null;
  departmentName?: string | null;
  timezone?: string;
  language?: string;
}

export interface UpdateUserData {
  username?: string;
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  roleId?: number;
  organizationName?: string | null;
  departmentName?: string | null;
  isActive?: boolean;
  timezone?: string;
  language?: string;
}

export interface UserListResponse {
  success: boolean;
  data: User[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const userService = {
  async list(params?: {
    page?: number;
    limit?: number;
    search?: string;
    roleId?: number;
    isActive?: boolean;
  }): Promise<UserListResponse> {
    const response = await api.get('/users', { params });
    return response.data;
  },

  async getById(id: number): Promise<{ success: boolean; data: User }> {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  async create(data: CreateUserData): Promise<{ success: boolean; data: User }> {
    const response = await api.post('/users', data);
    return response.data;
  },

  async update(id: number, data: UpdateUserData): Promise<{ success: boolean; data: User }> {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
};

export const roleService = {
  async list(): Promise<{ success: boolean; data: Role[] }> {
    const response = await api.get('/roles');
    return response.data;
  },

  async getById(id: number): Promise<{ success: boolean; data: Role }> {
    const response = await api.get(`/roles/${id}`);
    return response.data;
  },
};

